var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcToggleUncheckGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_811_17773)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.57001,
    width: 28.3555,
    height: 16.86,
    rx: 8.43,
    fill: "#F1F5F9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5929 11.0001C17.5929 14.3861 14.848 17.131 11.462 17.131C8.07596 17.131 5.33105 14.3861 5.33105 11.0001C5.33105 7.6141 8.07596 4.8692 11.462 4.8692C14.848 4.8692 17.5929 7.6141 17.5929 11.0001Z",
    fill: "#A9B6CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3311 7.57001V14.57H10.9198V8.9526H10.8825L9.33105 9.95813V8.67222L11.004 7.57001H12.3311Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_811_17773",
    x: 0.471,
    y: 0.0410073,
    width: 33.4135,
    height: 21.918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_811_17773"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_811_17773",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcToggleUncheckGray);
export default __webpack_public_path__ + "static/media/ic_toggle_uncheck_gray.c3e86d960009f80424947b3b5ef372ab.svg";
export { ForwardRef as ReactComponent };